
























import { defineComponent } from '@vue/composition-api';
import FileFilter from '@/renderer/components/drawer/components/FileList/FileFilter/index.vue';
import { FileSelectHandler } from '@/renderer/components/drawer/compositions/fileSelectHandler';
export default defineComponent({
  name: 'FileListSelector',
  components: {
    FileFilter,
  },
  props: {
    handler: {
      required: true,
      type: Object,
    },
  },
  setup(props, context) {
    const fileSelectHandler = props.handler as FileSelectHandler;
    const methods = {
      changeHandler(activeIndex: any) {
        const list = fileSelectHandler.filteredFileList.value;
        if (list.length <= activeIndex) return;
        fileSelectHandler.selectedIndex.value = activeIndex;
      },
    };
    return {
      visible: fileSelectHandler.shouldShowFileSelector,
      filteredFileList: fileSelectHandler.filteredFileList,
      selectedIndex: fileSelectHandler.selectedIndex,
      fileSelectHandler,
      changeHandler: methods.changeHandler,
    };
  },
});
